import axios from "axios";

export async function logout(navigate) {
  let auth = localStorage.getItem("auth");
  let authObj = JSON.parse(auth);
  await axios.post(
    `${process.env.REACT_APP_API_URL}/api/auth/logout`,
    {},
    { headers: { Authorization: `Bearer ${authObj.token}` } }
  );

  // Remove token + user info
  localStorage.removeItem("auth");
  //logout(navigate);

  // Redirect to login screen
  navigate("/authentication/sign-in", { replace: true });
}

export async function clearTokenAndRedirectToLogin(navigate) {
  // Remove token + user info
  localStorage.removeItem("auth");
  // Redirect to login screen
  navigate("/authentication/sign-in", { replace: true });
}
